import { render, staticRenderFns } from "./ApexoInputGroup.vue?vue&type=template&id=56a272fc&"
import script from "./ApexoInputGroup.vue?vue&type=script&lang=js&"
export * from "./ApexoInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports